/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import CloudUpload from '@material-ui/icons/CloudUpload';

import { ButtonBase } from '@material-ui/core';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useStyles from './styles';

const Upload = (props) => {
  const { customProps, onClick, size } = props;
  const classes = useStyles({ size });
  return (
    <ButtonBase {...customProps} onClick={onClick} className={classnames(classes.button, customProps.className)}>
      <CloudUpload />
    </ButtonBase>
  );
};

Upload.propTypes = {
  onClick: PropTypes.func,
  customProps: PropTypes.object,
  size: PropTypes.number.isRequired,
};

Upload.defaultProps = {
  customProps: {},
  size: 48,
};

export default Upload;
